import { StatModule } from "@/core/modules/stat/objects/StatModule";

import EmployeeByDutyView from "./views/EmployeeByDutyView.vue";

export const employeeByDuty: StatModule = new StatModule("examination", "EmployeeByDuty", "examination", EmployeeByDutyView);
